// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.
// dp0.x is the pre-launch range: the first public release on televicentrodelvalle.com is dp1.0.

const CHANGELOG = [
    {
        version: 'dp0.1',
        date: '2026-10-06',
        title: 'Propuesta inicial de la landing',
        notes: [
            { type: 'feature', text: 'Landing de una página con servicios, equipos, trayectoria, reel y contacto por WhatsApp' },
            { type: 'feature', text: 'Página de política de tratamiento de datos personales' },
        ],
    },
];

export default CHANGELOG;
